import packageInfo from "../../package.json";

export const environment = {
  appVersion: packageInfo.version,
  production: false,
  API_DOMAIN: "http://localhost:3004",
  SERVICES: {
    AUTH: "/api",
    ADMIN: "/api/",
    COMPANY_ME: "/api/",
  },
};
